module.exports = __webpack_public_path__ + "static/media/bg-1.d960f423.png";